import request from '@/utils/request'
import axios from 'axios'
// 发送短信验证码
export function sendSms(data) {
  return request({
    url: '/zhixiao/api/login/smsVerificationCode',
    method: 'post',
    data
  })
}

// 预约试驾
export function appointmentDrive(data) {
  return request({
    url: '/zhixiao/api/homePage/v2/appointmentDrive',
    method: 'post',
    data
  })
}

// 获取全国省市二级行政区划树
export function getCityTree2() {
  return request({
    url: '/zhixiao/api/base/getCityTree2',
    method: 'get'
  })
}

// 获取经销商列表
export function getDealerList(data, location) {
  return request({
    url: '/zhixiao/api/dealer/queryPage',
    method: 'post',
    headers: {
      lat: location.lat,
      lon: location.lon
    },
    data
  })
}

// 获取抽奖结果
// export function draw() {
//   // 2-华为手机，3-10积分，null-已参与,7-谢谢参与
//   return new Promise((resolve) => {
//     resolve({
//       actiGoodsId: 2,
//       goodsName: '华为手机',
//       lastTimes: 0
//     })
//   })
// }

// 获取抽奖结果
export function draw(data) {
  return request({
    url: '/zhixiao/api/acti/lpfh/luckdraw',
    method: 'post',
    data
  })
}

// 保存收获地址
export function saveAddress(data) {
  return request({
    url: '/zhixiao/api/acti/lpfh/updateaddr',
    method: 'post',
    data
  })
}

// 获取海报配置
export function getPosterConfig(params) {
  return request({
    url: '/zhixiao/api/acti/lpfh/getbylpid',
    method: 'get',
    params
  })
}

// 获取大转盘配置
export function getLotteryConfig(params) {
  return request({
    url: '/zhixiao/api/acti/lpfh/getbybttid',
    method: 'get',
    params
  })
}

// 获取车辆列表
export function getCarList(data) {
  return request({
    url: '/zhixiao/api/acti/lpfh/getlpcarlist',
    method: 'post',
    data
  })
}

// 获取车辆列表
export function getModelList(params) {
  return request({
    url: '/zhixiao/api/acti/lpfh/getCarModelByAct',
    method: 'get',
    params
  })
}

// wx config
export function getWxConfig(data) {
  return request({
    url: 'https://jacwxmp.starnetah.com:9443/wx/service/login/wxSignature',
    method: 'post',
    data
  })
}
// 获取问卷详情
export function getQuestionnaire(params) {
  return request({
    url: '/zhixiao/api/questionnaire/getQuestionnaire',
    method: 'get',
    params
  })
}
// 提交问卷
export function getanswer(data) {
  return request({
    url: '/zhixiao/api/questionnaire/answer',
    method: 'post',
    data
  })
}
// 获取投票详情
export function getbyactid(data) {
  return request({
    url: '/zhixiao/api/vote/getbyactid',
    method: 'post',
    data
  })
}
// 获取投票统计结果
export function getanssta(params) {
  return request({
    url: '/zhixiao/api/vote/getanssta',
    method: 'get',
    params
  })
}
// 提交投票
export function votecommit(data) {
  return request({
    url: '/zhixiao/api/vote/votecommit',
    method: 'post',
    data
  })
}

// 获取品牌字典
export function getBrandDict() {
  return request({
    url: '/zhixiao/api/base/getBrandDict',
    method: 'get'
  })
}

// 获取车系字典
export function getSeriesDict(params) {
  return request({
    url: '/zhixiao/api/base/getSeriesDict',
    method: 'get',
    params
  })
}

// 获取车型字典
export function getModelDict(params) {
  return request({
    url: '/zhixiao/api/base/getModelDict',
    method: 'get',
    params
  })
}

// 获取帮砍微信配置
export function patternCutInfo(params) {
  return request({
    url: '/zhixiao/api/activity/cut/patternCutInfo',
    method: 'get',
    params
  })
}
// 获取车型字典
export function getModelTree(params) {
  console.log(params)
  return request({
    url: '/zhixiao/api/base/getModelTree'
  })
}
// 获取新版问卷题目
export function getNewQuestionnaire(data) {
  return request({
    url: '/zhixiao/api/questionnaire/getQuestionnaire',
    method: 'post',
    data
  })
}
// 新版提交问卷
export function commitQuestionnaire(data) {
  return request({
    url: '/zhixiao/api/questionnaire/answer',
    method: 'post',
    data
  })
}
// 新版获取问卷预览（问卷管理预览，带管理端 token）
export function getNewQuestionnairePreview(params, token) {
  return request({
    url: '/zhixiao/mgr/questionnaire/detail',
    method: 'get',
    headers: {
      Token: token || ''
    },
    params
  })
}

// 换取openid
export function wxGetAccessToken(data) {
  return request({
    url: `${process.env.VUE_APP_WX_API}/login/wxGetAccessToken`,
    method: 'post',
    data
  })
}

// 获取图形验证码sessionId
export function getPictureSessionId(params) {
  return request({
    url: '/zhixiao/api/code/getSessionId',
    method: 'get',
    params
  })
}
// 获取图形验证码
export function getPictureCode(data) {
  return request({
    // url: '/zhixiao/api/code/getCode',
    url: `/zhixiao/api/code/getCode?sessionId=${data.sessionId}`,
    responseType: 'arraybuffer',
    method: 'post'
    // method: 'post',
    // data
  })
}

// 图形验证码校验
export function checkPictureCode(data) {
  return request({
    url: '/zhixiao/api/code/v2/checkCode',
    method: 'post',
    data
  })
}
// 转介绍线索资格认定
export function qualification(params) {
  return axios.get(`https://jacwxmp.starnetah.com:19000/v2driver/referral/qualification/v2?userId=${params.userId}`)
}
// 添加介绍买车
export function add(data) {
  return axios.post('https://jacwxmp.starnetah.com:19000/v2driver/referral/add/v2', data)
}

// 查询指定品牌的所有车型
export function getCarModelByBrandId(data) {
  return request({
    url: '/zhixiao/api/scCar/getCarModelByBrandId',
    method: 'post',
    data
  })
}

// 获取金融购车专题详情
export function getFinanceTopicDetail(params) {
  return request({
    url: '/zhixiao/api/financeTopic/detail',
    method: 'get',
    params
  })
}
